<template>
  <div>
    <header>
      <section>
        <div class="col1">
          <router-link id="logo" to="uploader"
            ><h3>JustOneMore</h3></router-link
          >
        </div>
      </section>
    </header>
    <div class="blueprints-wrapper">
      <div class="md-form container container-custom">
        <div id="divMessage" class="form-group">
          {{ message }}
        </div>
        <div class="form-group">
          <label>Blueprint location:</label>
          <input v-model.trim="blueprint" class="form-control" required />
        </div>
        <div class="form-group">
          <label>Blueprint story ID:</label>
          <input v-model.trim="storyId" class="form-control" required />
        </div>
        <button v-on:click="submitBlueprint()" class="btn btn-primary">
          Submit
        </button>
      </div>
      <audio id="my-audio"></audio>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ApiService from "@/services/api/Mainapi";
import { fbStorage } from "@/firebaseConfig.js";
let testduration = "";
export default {
  data() {
    return {
      loading: true,
      message: "",
      blueprint: "",
      storyId: null,
    };
  },
  methods: {
    submitBlueprint() {
      if (this.checkValidation()) {
        this.addErrorMessage();
        return;
      }
      // var storageRef = fbStorage
      //   .ref("audios")
      //   .child(new Date() + "-" + this.file.name);
      // const uploadingTask = storageRef.put(this.file);

      ApiService.uploadBlueprint(
        this.blueprint,
        this.storyId,
      )
        .then((response) => {
          this.message = "Blueprint successfully submitted.";
          $("#divMessage").addClass("alert").addClass("alert-success");
        })
        .catch((error) => {
          console.log(error);
          this.addErrorMessage();
        });

      // uploadingTask
      //   .then(snap => {
      //     snap.ref.getDownloadURL().then((url) => {
      //       // alert("URL" + url)
      //       this.uploadInfo.location = url
      //       this.uploadInfo.duration = this.duration
      //       // console.log("uploadinfo duration: " + testduration)
      //       this.audiourl = url
      //       var userID = localStorage.getItem('id')
      //       var coverurl = this.getCoverImg()
      //       // alert('Cover: ' + coverurl)
      //       ApiService.uploadAudio(this.uploadInfo, userID, testduration, coverurl)
      //         .then(response => {
      //           this.message = "Audio successfully submitted. Kids will love your new story."
      //           $('#divMessage').addClass("alert").addClass("alert-success")
      //         })
      //         .catch(error => {
      //           console.log(error)
      //           this.addErrorMessage()
      //         })
      //     })
      //     .catch(err => {
      //       console.log(err)
      //       this.addErrorMessage()
      //     })
      //   })
      //   .catch(err => {
      //     console.log(err)
      //     this.addErrorMessage()
      //   })
      //   .finally(function() {
      //       //this.loading = false
      //   });
    },
    addErrorMessage() {
      if (this.message == "") {
        this.message =
          "Sorry something went wrong. Please report if it continues";
      }
      $("#divMessage").addClass("alert").addClass("alert-danger");
    },
    checkValidation() {
      this.message = "";
      if (this.blueprint == "" || this.storyId == null) {
        this.message = "Please correctly fill out all the information.";
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
.blueprints-wrapper {
  width: 70%;
  margin: 12% auto;
}
.container-custom {
  max-width: 450px;
  margin-top: 20px;
}
textarea {
  min-height: 125px;
}
#logo {
  position: fixed;
  display: flex;
}
#inputLanguage {
  margin-top: 10px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Blueprints.vue